import React from "react";
import { useIntl } from "react-intl";
import { useSelector } from "react-redux";
import { object, array, string } from "yup";
import { Button, Row, Space } from "@masterteam/mt-design-react";

import Step from "./Step";

import "./style.scss";

export const workflowValidationSchema = object().shape({
  Workflows: array().of(
    object().shape({
      WorkflowSteps: array().of(
        object().shape({
          ArabicName: string().required(" "),
          EnglishName: string().required(" "),
          Approver: object().required(" ").nullable()
        })
      )
    })
  )
});

function WorkflowTab({ readOnly, groups = [], formBag }) {
  const intl = useIntl();
  const approvers = useSelector(
    ({ theme }) => theme.WorkflowApprovers.item.Items
  );
  const { values, setFieldValue, errors } = formBag;

  const data = values.Workflows?.[0]?.WorkflowSteps;

  const addItem = () => {
    const newVal = [...data];
    newVal.push({
      Approver: "",
      ArabicName: "",
      EnglishName: "",
      IsDeletable: false,
      Order: 1,
      isGroup: false
    });
    setFieldValue("Workflows[0].WorkflowSteps", newVal);
  };

  const removeItem = (index) => {
    const newSteps = [...data];
    newSteps.splice(index, 1);
    setFieldValue("Workflows[0].WorkflowSteps", newSteps);
  };

  return (
    <Space
      direction="vertical"
      size="medium"
      className="kpi-config__form__workflow-tab"
    >
      <Row justify="end">
        <Button onClick={addItem}>
          {intl.formatMessage({ id: "kpi-type.add-step" })}
        </Button>
      </Row>
      <div>
        {data?.map((e, i) => (
          <Step
            key={i}
            index={i}
            data={e}
            errors={errors?.Workflows?.[0]?.WorkflowSteps?.[i]}
            readOnly={readOnly}
            approvers={approvers}
            groups={groups}
            onChange={setFieldValue}
            hideRemove={data?.length === 1 || i === 0}
            removeItem={(obj) => removeItem(obj)}
          />
        ))}
      </div>
    </Space>
  );
}

export default WorkflowTab;
